import React, { Component } from "react";

const childAgeList = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

class PaxComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditRoom: false,
      selectedId: 1,
    };
  }

  OnClickAddRooms = (id) => {
    this.setState({ selectedId: id });
  };

  render() {

    const styles = this.props.data?.styles;

    console.log(this.props.data?.isSRP, 'CheckData')

    return (
      <>
        <div
          className={
            this.props.data?.isSRP
              ? styles.guest_cont_srp
              : styles.hotel_guestCont
          }
        >

          <div className={styles?.select_full_section}
            onClick={() => this.props.data.onClickVisibilityStatus("rooms")}
          >

          </div>
          <div
            className={
              styles?.hotel_search_column +
              " " +
              styles?.hotel_search_accomodation
            }
          >
            {!this.props.data?.isMobile &&
              <div
                className={styles?.hotel_cabin_class_cont}
              >
                <div className={styles?.hotel_cabin_class_name}>
                  <div
                    tabIndex="1"
                    onFocus={() => {
                      this.props.data.onInputFocus("rooms");
                    }}
                    className={styles?.adult_room_flex}
                  >
                    <div className={styles?.adult_room_icon}>
                      <img src="/images/person.svg" alt="person" />
                    </div>
                    <span className={styles?.adult_room_title}>
                      {this.props.data.state.selectedRoomDetails.rooms}{" "}
                      {this.props.data.state.selectedRoomDetails.rooms > 1
                        ? "Rooms"
                        : "Room"}
                      {", "}
                      {this.props.data.state.selectedRoomDetails.guest}{" "}
                      {this.props.data.state.selectedRoomDetails.guest > 1
                        ? " Guests"
                        : " Guest"}
                    </span>
                  </div>
                </div>
              </div>}

            {(this.props.data?.isMobile ||
              this.props.data.state.openRoomDetailList === true) ? (
              <div className={!this.props.data?.isMobile ? styles?.parent_autocomplete : styles?.parent_autocomplete_mobile}>
              {this.props.data?.isMobile  && <h5 className={styles?.select_room_title}>Select Rooms & Guests</h5>}
                <div className={`${styles?.hotel_room_list} ${!this.props.data?.isMobile ? styles?.child_autocomplete : ""}`}>

                  <div className={styles?.hotel_room_list_main}>
                    {/* <p>Select Rooms & Guests</p> */}
                    {this.props.data.state.roomList.map((element, index) => {
                      let roomLength = this.props.data.state.roomList.length;
                      return (
                        <div
                          className={styles?.hotel_room_detail_ele}
                          key={index}
                        >
                          <div className={styles?.hotel_room_head}>
                            <div className={styles?.hotel_roomWrap}>
                              <div className={styles?.hotel_room_title}>
                                Room {index + 1}
                              </div>
                              {element.id !== this.state.selectedId && (
                                <div className={styles?.hotel_room_traveller}>

                                  {element?.adults > 1 ? `${element?.adults} Adults` : `${element?.adults} Adult`}
                                  {element?.children > 0 && (
                                    element?.children > 1 ? `, ${element?.children} children` : `, ${element?.children} Child`)}

                                </div>)}
                            </div>
                            {element.id !== this.state.selectedId ? (
                              <div className={styles?.hotel_room_container}>
                                <div
                                  className={styles?.hotel_room_remove}
                                  onClick={() => {
                                    this.OnClickAddRooms(element.id);
                                  }}
                                >
                                  Edit
                                </div>
                                <div
                                  className={styles?.hotel_room_edit}
                                  onClick={() => {
                                    this.props.data.removeRoomItem(roomLength);
                                    const newSelectedId = roomLength > 1 ? this.props.data.state.roomList[0].id : 1;
                                    this.setState({ selectedId: this.props.data.state.roomList[0].id });
                                  }}
                                >
                                  Remove
                                </div>
                              </div>
                            ) : null}
                          </div>


                          {element.id == this.state.selectedId && (
                            <div className={styles?.hotel_accomodation_main}>
                              <div className={styles?.hotel_adult_accomodation}>
                                <div className="hotel_adult_accomodation_tag">
                                  <p>Adults</p>
                                  <span>{this.props.data.adultLabel}</span>
                                </div>
                                <div className={styles?.hotel_accomodation_conf}>
                                  <span
                                    className={
                                      element.adultMinusCountDisable
                                        ? styles?.disbale_traveller +
                                        " " +
                                        styles?.hotel_accomodation_icon
                                        : styles?.hotel_accomodation_icon
                                    }
                                    onClick={() =>
                                      this.props.data.minusAccomodationCount(
                                        element.id,
                                        index,
                                        "adult"
                                      )
                                    }
                                  >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                      <path d="M7.25 12.75H16.75V11.25H7.25V12.75ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" fill="#BF711E" />
                                    </svg>
                                  </span>
                                  <div className={`${styles?.ac_count}`}>
                                    {element.adults}
                                  </div>
                                  <span
                                    className={
                                      element.adultAddCountDisable
                                        ? styles?.disbale_traveller +
                                        " " +
                                        styles?.hotel_accomodation_icon
                                        : styles?.hotel_accomodation_icon
                                    }
                                    onClick={() =>
                                      this.props.data.addAccomodationCount(
                                        element.id,
                                        index,
                                        "adult"
                                      )
                                    }
                                  >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                      <path d="M11.25 16.75H12.75V12.75H16.75V11.25H12.75V7.25H11.25V11.25H7.25V12.75H11.25V16.75ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" fill="#BF711E" />
                                    </svg>
                                  </span>
                                </div>
                              </div>
                              <div className={styles?.hotel_children_accomodation}>
                                <div className={styles?.children_accomodationTag}>
                                  <p>Children</p>
                                  <span>{this.props.data.childLabel}</span>
                                </div>
                                <div className={styles?.hotel_accomodation_conf}>
                                  <span
                                    className={
                                      element.childrenMinusCountDisable
                                        ? styles?.disbale_traveller +
                                        " " +
                                        styles?.hotel_accomodation_icon
                                        : styles?.hotel_accomodation_icon
                                    }
                                    onClick={() =>
                                      this.props.data.minusAccomodationCount(
                                        element.id,
                                        index,
                                        "children"
                                      )
                                    }
                                  >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                      <path d="M7.25 12.75H16.75V11.25H7.25V12.75ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" fill="#BF711E" />
                                    </svg>
                                  </span>
                                  <div className={`${styles?.ac_count} ${element.children == "0" ? styles?.count_zero_disabled : ''}`}>
                                    {element.children}
                                  </div>
                                  <span
                                    className={
                                      element.childrenAddCountDisable
                                        ? styles?.disbale_traveller +
                                        " " +
                                        styles?.hotel_accomodation_icon
                                        : styles?.hotel_accomodation_icon
                                    }
                                    onClick={() =>
                                      this.props.data.addAccomodationCount(
                                        element.id,
                                        index,
                                        "children"
                                      )
                                    }
                                  >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                      <path d="M11.25 16.75H12.75V12.75H16.75V11.25H12.75V7.25H11.25V11.25H7.25V12.75H11.25V16.75ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" fill="#BF711E" />
                                    </svg>
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                          {element.id == this.state.selectedId &&
                            <div
                              className={`${styles?.child_rowMain_container} ${!element.childDetails.length > 0
                                  ? styles?.child_rowMain_contSpace
                                  : ""
                                }`}
                            >
                               {this.props.data?.isMobile && element.childDetails.length > 0 && <div className={styles?.child_age_lable_mobile}> Pick the child’s age from below</div>}
                              {element.childDetails.length > 0 &&
                                element.childDetails.map((item, ind) => {
                                  return (
                                    <div
                                      className={styles?.child_row_container}
                                      key={ind}
                                    >
                                      <div className={styles?.child_row_main}>
                                        <div className={styles?.child_age_wrap}>
                                          <span className={styles?.child_age_lable}>
                                            Child Age
                                          </span>
                                          
                                          {/* Mobile View - Horizontal Age Selector */}
                                          {this.props.data?.isMobile ? (
                                            <div className={styles?.child_age_mobile_selector}>
                                              <div className={styles?.child_age_buttons_container}>
                                                {childAgeList.map((age, ageIndex) => (
                                                  <button
                                                    key={ageIndex}
                                                    className={`${styles?.child_age_button} ${
                                                      Number(item.age) === Number(age) ? styles?.child_age_button_selected : ''
                                                    }`}
                                                    onClick={() =>
                                                      this.props.data.isChildrenAge(
                                                        index,
                                                        ind,
                                                        "clickAge",
                                                        age
                                                      )
                                                    }
                                                  >
                                                    {age}
                                                  </button>
                                                ))}
                                              </div>
                                            </div>
                                          ) : (
                                            /* Desktop View - Dropdown */
                                            <div className={`${styles?.child_input_wrap} ${item.age ? styles?.selected_child_age : ''}`}>
                                              <input
                                                type="text"
                                                className={styles?.selected_age}
                                                placeholder="Select Age"
                                                value={item.age}
                                                onClick={() =>
                                                  this.props.data.isChildrenAge(
                                                    index,
                                                    ind,
                                                    "isOpen"
                                                  )
                                                }
                                                readOnly
                                              />
                                              <span
                                                className={
                                                  item.isOpen === true
                                                    ? styles?.child_age_select_arrow
                                                    : styles?.child_age_select_arrow_rot
                                                }
                                                onClick={() =>
                                                  this.props.data.isChildrenAge(
                                                    index,
                                                    ind,
                                                    "isOpen"
                                                  )
                                                }
                                              >
                                              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                                                <path d="M4.71146 5.58958L0 0.878126L0.878125 0L4.71146 3.83333L8.54479 0L9.42292 0.878126L4.71146 5.58958Z" fill="#BF711E"/>
                                              </svg>
                                              </span>
                                            </div>
                                          )}
                                          
                                        
                                        </div>
                                        {item.isError === true ? (
                                            <span className={styles?.err_message_text}>
                                              Please enter valid age
                                            </span>
                                          ) : null}
                                        
                                        {/* Desktop dropdown list - only show for desktop and when open */}
                                        {!this.props.data?.isMobile && item.isOpen === true ? (
                                          <div className={styles?.age_list_cont}>
                                            <div className={styles?.age_list_main}>
                                              {childAgeList.map((ele, i) => {
                                                return (
                                                  <div
                                                    key={i}
                                                    className={styles?.age_list_ele}
                                                    onClick={() =>
                                                      this.props.data.isChildrenAge(
                                                        index,
                                                        ind,
                                                        "clickAge",
                                                        ele
                                                      )
                                                    }
                                                  >
                                                    <span>{ele}</span>
                                                  </div>
                                                );
                                              })}
                                            </div>
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>}

                          {this.props.data.state.roomList.length < this.props.data?.totalRooms &&
                            index === this.props.data.state.roomList.length - 1 ? (
                            <div className={styles?.hotel_add_rooms_wrap}>
                              <div
                                className={styles?.hotel_add_rooms}
                                onClick={() => {
                                  this.props.data.handlePaxComp();
                                  this.OnClickAddRooms(this.props.data.state.roomList.length + 1);
                                }}
                              >
                                <div className={styles?.paxPlus_icon}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                  >
                                    <g clip-path="url(#clip0_536_3897)">
                                      <path
                                        d="M7.31641 7.5V1.5C7.31641 0.947715 7.76412 0.5 8.31641 0.5C8.86869 0.5 9.31641 0.947715 9.31641 1.5V7.5L15.3164 7.5C15.8687 7.5 16.3164 7.94772 16.3164 8.5C16.3164 9.05229 15.8687 9.5 15.3164 9.5L9.31641 9.5V15.5C9.31641 16.0523 8.86869 16.5 8.31641 16.5C7.76412 16.5 7.31641 16.0523 7.31641 15.5V9.5H1.31641C0.764121 9.5 0.316406 9.05228 0.316406 8.5C0.316406 7.94771 0.764122 7.5 1.31641 7.5H7.31641Z"
                                        fill="#BF711E"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_536_3897">
                                        <rect
                                          width="17"
                                          height="16"
                                          fill="white"
                                          transform="translate(0 0.5)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </div>
                                <p>Add Room </p>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      );
                    })}

                  </div>
                  <div className={styles?.done_button_main}>
                    <input
                      value="Apply"
                      className={styles?.done_button}
                      readOnly
                      onClick={() => this.props.data.onClickDoneButton()}
                      onBlur={this.props.data.focusOutDone}
                    />
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </>
    );
  }
}

export default PaxComp;
